<template>
  <PageContent type="center" :compClass="'flex flex-col space-y-6'">
    <div class="flex flex-row justify-between items-center content-center">
      <h1 class="text-2xl font-medium">
        Mail Errors
      </h1>
    </div>

    <CustomTable class="bg-white rounded shadow-md group">
      <template v-slot:header>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Name
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Bounce Type
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Status
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Date
        </th>
        <th
          class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
        >
          Context
        </th>
      </template>
      <template v-slot:body>
        <tr
          class="hover:bg-gray-200 cursor-pointer"
          v-for="error in errors"
          v-bind:key="error.id"
          v-on:click="
            () => {
              selectedError = error;
              $eventBus.$emit('admin-error-email-details-modal-open');
            }
          "
        >
          <td class="py-4 px-6 border-b border-grey-light">
            {{ error.user !== null ? error.user.name : error.email_address }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ error.bounce_type }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ error.status }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            {{ error.aws_timestamp | displayLocalDateTime }}
          </td>
          <td class="py-4 px-6 border-b border-grey-light">
            <span
              class="px-3 py-1  rounded-full text-sm"
              :class="{
                'bg-gray-200': error.mailDescription.status_code == 'unknown',
                'bg-gray-800 text-white':
                  error.mailDescription.status_code == 'blacklist',
                'bg-yellow-200':
                  error.mailDescription.status_code == 'address_unknown',
                'bg-red-200':
                  error.mailDescription.status_code == 'address_deleted',
                'bg-blue-200': error.mailDescription.status_code == 'hop_error'
              }"
              >{{ error.mailDescription.message }}</span
            >
          </td>
        </tr>
      </template>
    </CustomTable>

    <div class="flex flex-row items-center content-center justify-center">
      <div
        class="relative inline-flex rounded-md divide-x overflow-hidden shadow-md"
      >
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page >= 2"
          v-on:click="pagination.page = pagination.first"
        >
          <i class="fa-solid fa-backward-fast"></i>
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page >= 6"
          v-on:click="pagination.page -= 5"
        >
          <i class="fa-solid fa-backward-step"></i>
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page >= 3"
          v-on:click="pagination.page -= 2"
        >
          {{ pagination.page - 2 }}
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page >= 3"
          v-on:click="pagination.page -= 1"
        >
          {{ pagination.page - 1 }}
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-blue-600 text-white hover:bg-gray-200"
        >
          {{ pagination.page }}
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page + 1 < pagination.last"
          v-on:click="pagination.page++"
        >
          {{ pagination.page + 1 }}
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page + 2 < pagination.last"
          v-on:click="pagination.page += 2"
        >
          {{ pagination.page + 2 }}
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page + 5 < pagination.last"
          v-on:click="pagination.page += 5"
        >
          <i class="fa-solid fa-forward-step"></i>
        </button>
        <button
          class="focus:outline-none w-10 h-10 bg-white hover:bg-gray-200"
          v-if="pagination.page !== pagination.last"
          v-on:click="pagination.page = pagination.last"
        >
          <i class="fa-solid fa-forward-fast"></i>
        </button>
      </div>
    </div>
    <EmailErrorDetailsModal :selectedError="selectedError" />
  </PageContent>
</template>

<script>
import * as Config from "@/config";

import Modal from "@/components/Modal";
import PageContent from "@/components/PageContent";
import CustomTable from "@/components/general/CustomTable";
import EmailErrorDetailsModal from "@/screens/admin/modals/EmailErrorDetailsModal";

export default {
  name: "AdminToolsMailErrors",
  data() {
    return {
      errors: [],
      pagination: {
        page: 1,
        first: null,
        last: null
      },
      displayModal: false,
      selectedError: null
    };
  },
  components: { PageContent, CustomTable, Modal, EmailErrorDetailsModal },
  mounted() {
    this.getErrors();
  },
  watch: {
    "pagination.page": function(val) {
      this.getErrors();
    }
  },
  methods: {
    async getErrors() {
      let res = await this.$http.get(
        Config.apiPath +
          "/api/v2/admin/mail/errors?page=" +
          this.pagination.page
      );
      this.$set(this, "errors", res.data.data);
      this.pagination.first = 1;
      this.pagination.last = res.data.last_page;
    },
    viewInfoModal(error) {
      this.selectedError = error;
      this.displayModal = true;
    }
  }
};
</script>
